<!-- Product Basic Details-->
<div nz-row>
  <div *ngIf="false" nz-col nzSpan="24" class="task-item shadowed-on-hover">

      <!-- <nz-skeleton [nzAvatar]="false" [nzActive]="true" [nzTitle]="true" [nzLoading]="isLoading"> -->

        <div>
            <!-- DEMO CODE BELOW: DO NOT USE THIS IN PRODUCT(ION) USE ARRAYS AND LOOPS -->
            <!-- CLAIMS -->
            <div class="grid grid-4x grid-gap-10">
                <div *ngFor="let data of basicDetails['data']">
                    <!-- <strong class="c-s-heading">{{data.fieldName}}</strong> {{data.fieldValue}} -->
                    <div>
                        <strong class="c-s-heading">{{data.title | titlecase}}</strong>
                        <span class="c-s-data" *ngIf="!data.type">
                            {{data.value}}
                        </span>
                        <nz-container class="m-t-5" *ngIf="data.type && data.type == 'csv'">
                            <nz-tag *ngFor="let productDetails of data.value">{{productDetails | technicalTranslate}}</nz-tag>
                        </nz-container>
                    </div>
                </div>
            </div>
        </div>

          <div class="task-item-foot">
              <span>Launch Date: {{launchDate}}</span>
              <span></span>
              <span>Withdraw Date: {{withdrawDate}} </span>
          </div>

      <!-- </nz-skeleton> -->

  </div>
</div>
<!--END: Product Basic Details-->

<!--Product Statics Details-->
<div class="productStatics-area">
  <h3 class="productStaticsTitle">
      Proposal Review
  </h3>
  <div *ngIf="false">
    <div class="productStatics-card card-orange">
      <div class="productStatics-card-number">10</div>
      <div class="productStatics-card-label">Vocabularies</div>
    </div>
  
    <div class="productStatics-card card-pink">
      <div class="productStatics-card-number">20</div>
      <div class="productStatics-card-label">Rules</div>
    </div>
  
    <div class="productStatics-card card-green">
      <div class="productStatics-card-number">30</div>
      <div class="productStatics-card-label">Lookups</div>
    </div>
  </div>

    <!-- <div *ngIf="false" class="stat-widgets p-t-0 grid grid-5x grid-gap-20 grid-5x-responsive">
      <div *ngFor="let item of dataCARDS; let i=index;" class="stat-widget"
        [ngStyle]="{ 'backgroundColor': colorScheme.domain[i] }">
        <div class="stat-widget-body" (click)="onCardChange(item, i)">
          <strong>{{item.value}}</strong>
          {{item.name}}
        </div>
      </div>
    </div> -->
    <ng-container *ngIf="isLoading">
      <div class="widget-loading" *ngFor="let i of [1];" style="height:150px">
        <p><i nz-icon nzType="loading" theme="outline"></i>&nbsp; Loading Proposal Details...</p>
      </div>
    </ng-container>
    <div class="grid grid-3x grid-gap-20 grid-3x-responsive">
      <!-- [ngClass]="(!item.value ||  item.value == 0 ) ? 'cur-disabled' : 'cur-pointer'" -->
          <div class="widget-small-analytics" [ngClass]="{active: activeCardIndex == index}" *ngFor="let item of data_Cards; let index=index;" (click)="showDetailedData(index, item)">
            <div class="content">
              <div nz-row>
                <div nz-col nzMd="18">
                  <div class="numbers">
                    <p class="text-t-caps">{{item.name}}</p>
                    <strong class="color-" *ngIf="item.value">Risk Score : {{item.value}}</strong>
                    <strong class="color-" *ngIf="item.moreInfo && item.name == 'Portfolio Impact'">Score : {{item.moreInfo}}</strong>
                    <i style="font-size:small;" *ngIf="item.moreInfo && item.name != 'Portfolio Impact'">{{item.moreInfo}}</i>
                  </div>
                </div>
                <div nz-col nzMd="6" class="text-a-right">
                  <div class="icon-big icon-warning text-center">
                    <i nz-icon [nzType]="item.icon" theme="outline"></i>
                  </div>
                </div>
              </div>
              <div *ngIf="item.desc" class="widget-small-footer">
                <div class="stats">
                  <span [innerHtml]="item.desc"></span>
                </div>
              </div>
            </div>
          </div>
        <!-- <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12">
          <div class="widget-small-analytics">
            <div class="content">
              <div nz-row>
                <div nz-col nzMd="16">
                  <div class="numbers">
                    <p>Average Level<span></span></p>
                    <strong class="color-">SILVER</strong>
                  </div>
                </div>
                <div col nzMd="8">
                  <div class="icon-big icon-warning text-center">
                    <i nz-icon nzType="crown" theme="outline"></i>
                  </div>
                </div>
              </div>
              <div class="widget-small-footer">
                <div class="stats">
                  <b>Next Milestone</b>: 50,000 cumulative team points for L3
                </div>
              </div>
            </div>
          </div>
        </div> -->
      </div>

</div>
<!--END: Product Statics Details-->

<!--Product Details-->

<div class="productStatistics-result-area" *ngIf="activeCardIndex == 0 || activeCardIndex > 0">
  <!-- <div [ngStyle]="{ 'backgroundColor': colorScheme.domain[currentCardIndex] }" style="width:100%; height:5px;"> -->
  <!-- </div> -->
  <!-- <h3 class="productStaticsTitle">
    Filter Rule
  </h3> -->
  <!-- <div>
    <nz-radio-group [(ngModel)]="radioValue" nzButtonStyle="solid">      <label nz-radio-button nzValue="A">FNOL</label>      <label nz-radio-button nzValue="B">Eligibility Rules</label>      <label nz-radio-button nzValue="C">Payout</label>      <label nz-radio-button nzValue="D">FWA</label>    </nz-radio-group>
    </div> -->
  <div class="m-b-20 text-a-right" *ngIf="activeEntityName == 'attributes' || activeEntityName == 'benefits' || activeEntityName == 'exclusions' || activeEntityName == 'coverages'">
    <a (click)="redirectToStep()">Go to {{activeEntityName |  titlecase }}</a>
  </div>

<div class="m-b-15">
    <!-- <h3 class="productStaticsTitle">
        Configured rules
    </h3> -->
    <div *ngIf="showDetailedDataSection && activeEntityName != 'proposal details' && activeEntityName != 'underwriting risk' && activeEntityName != 'medical risk' && activeEntityName != 'fraud risk'">
        <!-- <app-data-list [listOfData]="showCardDetails" [title]="activeEntityName" [listConfiguration]="listConfiguration" 
            [configData]="configData" [payloadInEdit]="inputDataForEdit" [filterBasedOn]="filterBasedOn"></app-data-list> -->
           <div> 
            <div class="title-emphasis">
              <!-- <i class="title-ico anticon anticon-audit"></i> -->
              <span nz-icon nzType="audit" nzTheme="outline" class="title-ico"></span>
              <div>
                  <h4 class="p-0 m-0">{{titlecase}} Summary</h4>
              </div>
            </div>
            <div *ngIf = "selectedCardSummary">
              {{selectedCardSummary}}
            </div>
          </div>
    </div>

    <div *ngIf="activeEntityName == 'proposal details'">
      <nz-tabset>
        <nz-tab [nzTitle]="titleTmplBasicDtl" (nzSelect)="log(['select', tab])" (nzClick)="log(['click', tab])" (nzDeselect)="log(['deselect', tab])">
          <ng-template #titleTmplBasicDtl><i nz-icon nzType="file-protect"></i> Proposal Review</ng-template>
          <underwriting-worksheet [IO]="policyData" [transactionState]="transactionState" [enableDownload]="false" [enableLogo]="false"></underwriting-worksheet>
        </nz-tab>
        
        <nz-tab [nzTitle]="titleTmplBasicDt2" (nzSelect)="log(['select', tab])" (nzClick)="log(['click', tab])" (nzDeselect)="log(['deselect', tab])">
          <ng-template #titleTmplBasicDt2><i nz-icon nzType="file-protect"></i> Insured Wise Review </ng-template>
          <nz-tabset style="height:auto" [nzTabPosition]="'left'">
            <nz-tab [nzTitle]="titleTmplInsuredDecision" *ngIf="primaryInsured;">
              <ng-template #titleTmplInsuredDecision>
                <strong class="d-b">Insured : {{primaryInsured.name}}</strong>
                <p *ngIf="primaryInsured" [class.col-green]="'PRIMARY'" class="m-b-5">
                  <!-- <i nz-icon nzType="close-circle" nzTheme="outline" class="m-r-5"></i> -->
                 Primary Insured
                </p>
              </ng-template>
              <div>
                <!-- <span>{{insuredObj.name}} details : </span> -->
                <div class="underwriting-container summary-container-wide">
                  <div *ngFor="let field of personDetailsToShow">
                  <div *ngIf="primaryInsured[field.fieldKey]">
                    <span class="s-c-head">{{field.fieldValue}}</span>
                    <span *ngIf="field && field.pipe && field.pipe != 'CurrencyFormatter'">{{primaryInsured[field.fieldKey] | technicalTranslate}}</span>
                    <span *ngIf="field && field.pipe && field.pipe == 'CurrencyFormatter'">{{primaryInsured[field.fieldKey] | CurrencyFormatter : (appMetadataHandler.productCurrencyCd ||  appMetadataHandler.companyCurrencyCd || appMetadataHandler.currentCountryCdValue)}}</span>
                    <span *ngIf="field && !field.pipe">{{primaryInsured[field.fieldKey]}}</span>
                    <ng-template #showData>
                      <span>{{primaryInsured[field.fieldKey]}}</span>
                    </ng-template>
                  </div>
                  </div>
                </div>
              </div>
            </nz-tab>
            <ng-container *ngIf="listOfinsured">
            <nz-tab [nzTitle]="titleTmplInsuredDecision" *ngFor="let insured of listOfinsured;let i = index">
              <ng-template #titleTmplInsuredDecision>
                <strong class="d-b">Insured {{i + 1}}: {{insured.name}}</strong>
                  <p *ngIf="insured"
                    class="m-b-5">
                  Insured Member
                  </p>
              </ng-template>
              <div>
                <!-- <span>{{insuredObj.name}} details : </span> -->
                <div class="underwriting-container summary-container-wide">
                  <div *ngFor="let field of personDetailsToShow">
                  <div *ngIf="insured[field.fieldKey]">
                    <span class="s-c-head">{{field.fieldValue}}</span>
                    <span *ngIf="field && field.pipe;else showData">{{insured[field.fieldKey] | technicalTranslate}}</span>
                    <ng-template #showData>
                      <span>{{insured[field.fieldKey]}}</span>
                    </ng-template>
                  </div>
                  </div>
                </div>
              </div>
            </nz-tab>
            </ng-container>
          </nz-tabset>
        </nz-tab>
      </nz-tabset>
    </div>

    <div *ngIf="activeEntityName == 'underwriting risk'">
      <risk-summarization [IO]="policyData" [transactionState]="transactionState"></risk-summarization>
    </div>

    <div *ngIf="activeEntityName == 'medical risk'">
      <app-medical-risk [IO]="policyData" [transactionState]="transactionState" [RequirementEntityGuid]="RequirementEntityGuid" [showLabReportSummary]="true"></app-medical-risk>
    </div>

    <div *ngIf="activeEntityName == 'fraud risk'">
      <!-- <app-fraud-rules *ngIf="dataTransformService.barCodeNum" [IO]="policyData" [transactionState]="transactionState"
          [barcodeNum]='dataTransformService.barCodeNum' [enableFraudRulePanel]="false" [enableAnomalyPanel]="false">
          </app-fraud-rules>
          <nz-skeleton *ngIf="!dataTransformService.barCodeNum" [nzAvatar]="false" [nzActive]="true"
          [nzLoading]="!dataTransformService.barCodeNum"></nz-skeleton> -->
          <app-fwa-analytics [IO]="policyData" [configData]="configData"
          [transactionState]="transactionState"></app-fwa-analytics>
    </div>
    

    <!-- <nz-table *ngIf="showCardDetails && showCardHeaders" #capturedDataTable nzBordered [nzData]="showCardDetails">
        <thead>
            <tr>
                <th scope="col" *ngFor="let rowData of showCardHeaders">{{rowData.fieldValue}}</th>
                <th scope="col">Action</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td *ngFor="let item of capturedDataTable.data">{{item.fieldValue || '-'}}</td>
                <td class="text-a-center"><a>View</a></td>
            </tr>
        </tbody>
    </nz-table> -->
</div>
</div>
<!--END: Product  Details-->
